import { AxiosPrivado } from '../componentes/axios/Axios';
import {
  PlanillasPeriodosListar,
  PlanillasGenerar,
  PlanillasDetalle,
  PlanillasAprobar,
  PlanillasReciboEmpleado,
  EmpleadosConfiguracionLaboral,
  EmpleadosPrestamos,
  VentaFiltro,
  VentaListar,
} from '../configuracion/apiUrls';

// Claves de almacenamiento local para persistencia del prototipo
const STORAGE_PERIODOS = 'sigvem_planillas_periodos';
const STORAGE_DETALLES = 'sigvem_planillas_detalles';
const STORAGE_CONFIG = 'sigvem_planillas_config_empleados';
const STORAGE_PRESTAMOS = 'sigvem_planillas_prestamos';

// Configuración inicial de empleados con modalidades de contratación
const SEED_CONFIG_EMPLEADOS = [
  {
    empleadoId: 9,
    nombreEmpleado: 'Alberto Amador',
    cargo: 'Ejecutivo de Ventas',
    modalidad: 'BASE_MAS_COMISION',
    salarioBaseMensual: 10000.00,
    porcentajeComision: 3.0,
    aplicaIHSS: true,
    aplicaRAP: true,
    ventasHistoricasMes: 145000.00,
    observaciones: 'Vendedor senior zona centro',
  },
  {
    empleadoId: 10,
    nombreEmpleado: 'Carlos Meza',
    cargo: 'Vendedor Mayorista',
    modalidad: 'SOLO_COMISION',
    salarioBaseMensual: 0.00,
    porcentajeComision: 5.0,
    aplicaIHSS: false,
    aplicaRAP: false,
    ventasHistoricasMes: 220000.00,
    observaciones: 'Comisionista puro por volumen mayorista',
  },
  {
    empleadoId: 11,
    nombreEmpleado: 'Sofia Reyes',
    cargo: 'Asesora Comercial',
    modalidad: 'BASE_MAS_COMISION',
    salarioBaseMensual: 9500.00,
    porcentajeComision: 2.5,
    aplicaIHSS: true,
    aplicaRAP: true,
    ventasHistoricasMes: 98000.00,
    observaciones: 'Ventas mostrador y cotizaciones corporativas',
  },
  {
    empleadoId: 1,
    nombreEmpleado: 'Juan Gómez',
    cargo: 'Gerente de Operaciones',
    modalidad: 'SUELDO_BASE',
    salarioBaseMensual: 22000.00,
    porcentajeComision: 0.0,
    aplicaIHSS: true,
    aplicaRAP: true,
    ventasHistoricasMes: 0.00,
    observaciones: 'Administración y supervisión de rutas',
  },
  {
    empleadoId: 2,
    nombreEmpleado: 'Laura Martínez',
    cargo: 'Contadora General',
    modalidad: 'SUELDO_BASE',
    salarioBaseMensual: 18500.00,
    porcentajeComision: 0.0,
    aplicaIHSS: true,
    aplicaRAP: true,
    ventasHistoricasMes: 0.00,
    observaciones: 'Gestión fiscal y contabilidad',
  },
  {
    empleadoId: 3,
    nombreEmpleado: 'Miguel Ángel Cruz',
    cargo: 'Jefe de Bodega e Inventarios',
    modalidad: 'SUELDO_BASE',
    salarioBaseMensual: 13000.00,
    porcentajeComision: 0.0,
    aplicaIHSS: true,
    aplicaRAP: true,
    ventasHistoricasMes: 0.00,
    observaciones: 'Control de lotes y stock físico',
  },
  {
    empleadoId: 4,
    nombreEmpleado: 'Elena Morales',
    cargo: 'Cajera Principal',
    modalidad: 'SUELDO_BASE',
    salarioBaseMensual: 11500.00,
    porcentajeComision: 0.0,
    aplicaIHSS: true,
    aplicaRAP: true,
    ventasHistoricasMes: 0.00,
    observaciones: 'Atención en caja y cobros diarios',
  },
  {
    empleadoId: 5,
    nombreEmpleado: 'Roberto Hernández',
    cargo: 'Conductor / Distribución',
    modalidad: 'SUELDO_BASE',
    salarioBaseMensual: 10500.00,
    porcentajeComision: 0.0,
    aplicaIHSS: true,
    aplicaRAP: true,
    ventasHistoricasMes: 0.00,
    observaciones: 'Entregas a domicilio de pedidos',
  },
];

// Préstamos iniciales de ejemplo
const SEED_PRESTAMOS = [
  {
    id: 1,
    empleadoId: 9,
    nombreEmpleado: 'Alberto Amador',
    montoOriginal: 6000.00,
    cuotaPeriodica: 500.00,
    totalCuotas: 12,
    cuotasPagadas: 4,
    saldoPendiente: 4000.00,
    motivo: 'Anticipo para gastos médicos familiares',
    estado: 'ACTIVO',
    fechaInicio: '2026-08-01',
  },
  {
    id: 2,
    empleadoId: 5,
    nombreEmpleado: 'Roberto Hernández',
    montoOriginal: 4000.00,
    cuotaPeriodica: 400.00,
    totalCuotas: 10,
    cuotasPagadas: 2,
    saldoPendiente: 3200.00,
    motivo: 'Préstamo para reparación de vehículo personal',
    estado: 'ACTIVO',
    fechaInicio: '2026-09-01',
  },
];

// Períodos iniciales de ejemplo
const SEED_PERIODOS = [
  {
    id: 1,
    codigo: 'PLN-2026-10-Q1',
    descripcion: 'Planilla 1ra Quincena Octubre 2026',
    tipoPeriodo: 'QUINCENAL',
    fechaInicio: '2026-10-01',
    fechaFin: '2026-10-15',
    totalBruto: 52400.00,
    totalComisiones: 9475.00,
    totalDeducciones: 4620.50,
    totalNeto: 57254.50,
    totalEmpleados: 8,
    estado: 'PAGADA',
    fechaCreacion: '2026-10-15',
    fechaPago: '2026-10-15',
  },
  {
    id: 2,
    codigo: 'PLN-2026-10-Q2',
    descripcion: 'Planilla 2da Quincena Octubre 2026',
    tipoPeriodo: 'QUINCENAL',
    fechaInicio: '2026-10-16',
    fechaFin: '2026-10-31',
    totalBruto: 52400.00,
    totalComisiones: 10850.00,
    totalDeducciones: 4710.20,
    totalNeto: 58539.80,
    totalEmpleados: 8,
    estado: 'APROBADA',
    fechaCreacion: '2026-10-24',
    fechaPago: null,
  },
];

// Helper para leer del localStorage con fallback
const getStorageItem = (key, defaultVal) => {
  try {
    const item = localStorage.getItem(key);
    return item ? JSON.parse(item) : defaultVal;
  } catch (err) {
    console.error('Error leyendo del storage:', err);
    return defaultVal;
  }
};

const setStorageItem = (key, val) => {
  try {
    localStorage.setItem(key, JSON.stringify(val));
  } catch (err) {
    console.error('Error guardando en storage:', err);
  }
};

// Inicializador de almacén prototipo
const initStorage = () => {
  if (!localStorage.getItem(STORAGE_CONFIG)) {
    setStorageItem(STORAGE_CONFIG, SEED_CONFIG_EMPLEADOS);
  }
  if (!localStorage.getItem(STORAGE_PRESTAMOS)) {
    setStorageItem(STORAGE_PRESTAMOS, SEED_PRESTAMOS);
  }
  if (!localStorage.getItem(STORAGE_PERIODOS)) {
    setStorageItem(STORAGE_PERIODOS, SEED_PERIODOS);
  }
};

initStorage();

/**
 * Calcula el desglose salarial de un empleado según los lineamientos técnicos
 */
export const calcularDetalleEmpleado = (empConfig, ventasPeriodo, tipoPeriodo, prestamoActivo = null, bonos = 0, otrasDeducciones = 0) => {
  const esQuincenal = tipoPeriodo === 'QUINCENAL';
  const divisor = esQuincenal ? 2 : 1;

  let salarioBasePeriodo = 0;
  let montoComision = 0;

  switch (empConfig.modalidad) {
    case 'SUELDO_BASE':
      salarioBasePeriodo = empConfig.salarioBaseMensual / divisor;
      montoComision = 0;
      break;

    case 'BASE_MAS_COMISION':
      salarioBasePeriodo = empConfig.salarioBaseMensual / divisor;
      montoComision = ((ventasPeriodo || 0) * (empConfig.porcentajeComision || 0)) / 100;
      break;

    case 'SOLO_COMISION':
      salarioBasePeriodo = 0;
      montoComision = ((ventasPeriodo || 0) * (empConfig.porcentajeComision || 0)) / 100;
      break;

    default:
      salarioBasePeriodo = empConfig.salarioBaseMensual / divisor;
      montoComision = 0;
  }

  const totalIngresos = Number((salarioBasePeriodo + montoComision + (bonos || 0)).toFixed(2));

  // Deducción IHSS: 3.5% sobre salario con techo cotizable hondureño (aprox L 10,796.49 mensual)
  const techoIHSSMensual = 10796.49;
  const techoIHSS = techoIHSSMensual / divisor;
  const baseIHSS = Math.min(salarioBasePeriodo > 0 ? salarioBasePeriodo : totalIngresos, techoIHSS);
  const deduccionIHSS = empConfig.aplicaIHSS ? Number((baseIHSS * 0.035).toFixed(2)) : 0;

  // Deducción RAP: 1.5% sobre el excedente del techo legal
  let deduccionRAP = 0;
  if (empConfig.aplicaRAP && salarioBasePeriodo > techoIHSS) {
    deduccionRAP = Number(((salarioBasePeriodo - techoIHSS) * 0.015).toFixed(2));
  }

  // Deducción Préstamo / Anticipo
  let deduccionPrestamo = 0;
  if (prestamoActivo && prestamoActivo.estado === 'ACTIVO' && prestamoActivo.saldoPendiente > 0) {
    deduccionPrestamo = Math.min(prestamoActivo.cuotaPeriodica, prestamoActivo.saldoPendiente);
  }

  const totalDeducciones = Number(
    (deduccionIHSS + deduccionRAP + deduccionPrestamo + (otrasDeducciones || 0)).toFixed(2)
  );

  const sueldoNeto = Number(Math.max(0, totalIngresos - totalDeducciones).toFixed(2));

  return {
    empleadoId: empConfig.empleadoId,
    nombreEmpleado: empConfig.nombreEmpleado,
    cargo: empConfig.cargo,
    modalidad: empConfig.modalidad,
    salarioBaseMensual: empConfig.salarioBaseMensual,
    salarioBasePeriodo: Number(salarioBasePeriodo.toFixed(2)),
    ventasPeriodo: Number((ventasPeriodo || 0).toFixed(2)),
    tasaComision: empConfig.porcentajeComision || 0,
    montoComision: Number(montoComision.toFixed(2)),
    bonificaciones: Number((bonos || 0).toFixed(2)),
    totalIngresos,
    deduccionIHSS,
    deduccionRAP,
    deduccionPrestamo: Number(deduccionPrestamo.toFixed(2)),
    otrasDeducciones: Number((otrasDeducciones || 0).toFixed(2)),
    totalDeducciones,
    sueldoNeto,
    prestamoId: prestamoActivo ? prestamoActivo.id : null,
  };
};

/**
 * SERVICIO PRINCIPAL DE PLANILLAS
 */
export const PlanillaServicio = {
  // 1. Obtener lista de períodos
  async listarPeriodos() {
    try {
      const resp = await AxiosPrivado.get(PlanillasPeriodosListar);
      if (resp && resp.data) {
        if (Array.isArray(resp.data)) {
          return resp.data;
        }
        if (Array.isArray(resp.data.periodos)) {
          return resp.data.periodos;
        }
        if (Array.isArray(resp.data.data)) {
          return resp.data.data;
        }
      }
    } catch (err) {
      // Backend aún no implementado -> Fallback prototipo local
    }
    return getStorageItem(STORAGE_PERIODOS, SEED_PERIODOS);
  },

  // 2. Obtener detalle de un período
  async obtenerDetallePeriodo(periodoId) {
    try {
      const resp = await AxiosPrivado.get(`${PlanillasDetalle}${periodoId}/detalle`);
      if (resp && resp.data) {
        return resp.data;
      }
    } catch (err) {
      // Fallback
    }

    const periodos = getStorageItem(STORAGE_PERIODOS, SEED_PERIODOS);
    const periodo = periodos.find((p) => p.id === Number(periodoId));
    if (!periodo) return null;

    const allDetalles = getStorageItem(STORAGE_DETALLES, {});
    let detalles = allDetalles[periodoId];

    // Si aún no existen detalles guardados para este período semilla, los generamos
    if (!detalles || !Array.isArray(detalles) || detalles.length === 0) {
      const configs = getStorageItem(STORAGE_CONFIG, SEED_CONFIG_EMPLEADOS);
      const prestamos = getStorageItem(STORAGE_PRESTAMOS, SEED_PRESTAMOS);

      detalles = configs.map((cfg) => {
        const prestamoActivo = prestamos.find(
          (pr) => pr.empleadoId === cfg.empleadoId && pr.estado === 'ACTIVO' && pr.saldoPendiente > 0
        );
        const ventasSimuladas = cfg.ventasHistoricasMes ? (periodo.tipoPeriodo === 'QUINCENAL' ? cfg.ventasHistoricasMes * 0.52 : cfg.ventasHistoricasMes) : 0;
        return calcularDetalleEmpleado(cfg, ventasSimuladas, periodo.tipoPeriodo, prestamoActivo);
      });

      allDetalles[periodoId] = detalles;
      setStorageItem(STORAGE_DETALLES, allDetalles);
    }

    return {
      periodo,
      detalles,
    };
  },

  // 3. Simular / Previsualizar cálculo antes de guardar
  async previsualizarCalculo({ tipoPeriodo, fechaInicio, fechaFin, ventasPorEmpleado = {} }) {
    const configs = getStorageItem(STORAGE_CONFIG, SEED_CONFIG_EMPLEADOS);
    const prestamos = getStorageItem(STORAGE_PRESTAMOS, SEED_PRESTAMOS);

    const detalles = configs.map((cfg) => {
      const prestamoActivo = prestamos.find(
        (pr) => pr.empleadoId === cfg.empleadoId && pr.estado === 'ACTIVO' && pr.saldoPendiente > 0
      );
      // Tomamos la venta ingresada o simulada para el período
      const venta = ventasPorEmpleado[cfg.empleadoId] !== undefined
        ? Number(ventasPorEmpleado[cfg.empleadoId])
        : (cfg.ventasHistoricasMes ? (tipoPeriodo === 'QUINCENAL' ? cfg.ventasHistoricasMes * 0.5 : cfg.ventasHistoricasMes) : 0);

      return calcularDetalleEmpleado(cfg, venta, tipoPeriodo, prestamoActivo);
    });

    const totalBruto = Number(detalles.reduce((acc, d) => acc + d.salarioBasePeriodo, 0).toFixed(2));
    const totalComisiones = Number(detalles.reduce((acc, d) => acc + d.montoComision, 0).toFixed(2));
    const totalDeducciones = Number(detalles.reduce((acc, d) => acc + d.totalDeducciones, 0).toFixed(2));
    const totalNeto = Number(detalles.reduce((acc, d) => acc + d.sueldoNeto, 0).toFixed(2));

    return {
      totalBruto,
      totalComisiones,
      totalDeducciones,
      totalNeto,
      totalEmpleados: detalles.length,
      detalles,
    };
  },

  // 4. Generar y guardar período de planilla
  async generarPlanilla({ descripcion, tipoPeriodo, fechaInicio, fechaFin, observaciones = '', ventasPorEmpleado = {} }) {
    try {
      const resp = await AxiosPrivado.post(PlanillasGenerar, {
        descripcion,
        tipoPeriodo,
        fechaInicio,
        fechaFin,
        observaciones,
      });
      if (resp && resp.data) {
        return resp.data;
      }
    } catch (err) {
      // Fallback
    }

    const { totalBruto, totalComisiones, totalDeducciones, totalNeto, totalEmpleados, detalles } =
      await this.previsualizarCalculo({ tipoPeriodo, fechaInicio, fechaFin, ventasPorEmpleado });

    const periodos = getStorageItem(STORAGE_PERIODOS, SEED_PERIODOS);
    const nextId = periodos.length > 0 ? Math.max(...periodos.map((p) => p.id)) + 1 : 1;
    const yearMonth = fechaFin.substring(0, 7).replace('-', '');
    const sufijo = tipoPeriodo === 'QUINCENAL' ? 'Q' : 'M';
    const codigo = `PLN-${yearMonth}-${sufijo}${nextId}`;

    const nuevoPeriodo = {
      id: nextId,
      codigo,
      descripcion: descripcion || `Planilla ${tipoPeriodo.toLowerCase()} ${fechaInicio} al ${fechaFin}`,
      tipoPeriodo,
      fechaInicio,
      fechaFin,
      totalBruto,
      totalComisiones,
      totalDeducciones,
      totalNeto,
      totalEmpleados,
      estado: 'BORRADOR',
      fechaCreacion: new Date().toISOString().split('T')[0],
      fechaPago: null,
      observaciones,
    };

    const periodosActualizados = [nuevoPeriodo, ...periodos];
    setStorageItem(STORAGE_PERIODOS, periodosActualizados);

    const allDetalles = getStorageItem(STORAGE_DETALLES, {});
    allDetalles[nextId] = detalles;
    setStorageItem(STORAGE_DETALLES, allDetalles);

    return {
      periodo: nuevoPeriodo,
      detalles,
    };
  },

  // 5. Aprobar período de planilla
  async aprobarPlanilla(periodoId) {
    try {
      const resp = await AxiosPrivado.put(`${PlanillasAprobar}${periodoId}/aprobar`);
      if (resp && resp.data) {
        return resp.data;
      }
    } catch (err) {
      // Fallback
    }

    const periodos = getStorageItem(STORAGE_PERIODOS, SEED_PERIODOS);
    const index = periodos.findIndex((p) => p.id === Number(periodoId));
    if (index === -1) throw new Error('Período no encontrado');

    periodos[index].estado = 'APROBADA';
    setStorageItem(STORAGE_PERIODOS, periodos);

    // Amortizar préstamos de los empleados incluidos
    const allDetalles = getStorageItem(STORAGE_DETALLES, {});
    const detalles = allDetalles[periodoId] || [];
    const prestamos = getStorageItem(STORAGE_PRESTAMOS, SEED_PRESTAMOS);

    detalles.forEach((det) => {
      if (det.prestamoId && det.deduccionPrestamo > 0) {
        const prIndex = prestamos.findIndex((pr) => pr.id === det.prestamoId);
        if (prIndex !== -1) {
          const pr = prestamos[prIndex];
          pr.cuotasPagadas += 1;
          pr.saldoPendiente = Math.max(0, Number((pr.saldoPendiente - det.deduccionPrestamo).toFixed(2)));
          if (pr.saldoPendiente <= 0) {
            pr.estado = 'FINALIZADO';
          }
        }
      }
    });

    setStorageItem(STORAGE_PRESTAMOS, prestamos);

    return {
      success: true,
      periodo: periodos[index],
    };
  },

  // 6. Marcar período como Pagada
  async pagarPlanilla(periodoId) {
    const periodos = getStorageItem(STORAGE_PERIODOS, SEED_PERIODOS);
    const index = periodos.findIndex((p) => p.id === Number(periodoId));
    if (index === -1) throw new Error('Período no encontrado');

    periodos[index].estado = 'PAGADA';
    periodos[index].fechaPago = new Date().toISOString().split('T')[0];
    setStorageItem(STORAGE_PERIODOS, periodos);

    return {
      success: true,
      periodo: periodos[index],
    };
  },

  // 7. Eliminar borrador de planilla
  async eliminarPeriodo(periodoId) {
    const periodos = getStorageItem(STORAGE_PERIODOS, SEED_PERIODOS);
    const periodo = periodos.find((p) => p.id === Number(periodoId));
    if (!periodo) throw new Error('Período no encontrado');
    if (periodo.estado !== 'BORRADOR') {
      throw new Error('Solo se pueden eliminar planillas en estado BORRADOR');
    }

    const filtrados = periodos.filter((p) => p.id !== Number(periodoId));
    setStorageItem(STORAGE_PERIODOS, filtrados);

    const allDetalles = getStorageItem(STORAGE_DETALLES, {});
    delete allDetalles[periodoId];
    setStorageItem(STORAGE_DETALLES, allDetalles);

    return { success: true };
  },

  // 8. Configuraciones laborales de empleados
  async listarConfiguraciones() {
    try {
      const resp = await AxiosPrivado.get(EmpleadosConfiguracionLaboral);
      if (resp && resp.data && Array.isArray(resp.data)) {
        return resp.data.map((item) => {
          if (item.empleadoId && item.nombreEmpleado) return item;

          const conf = item.empleadoConfiguracionSalarial || {};
          const nombreCompleto = [
            item.primerNombre,
            item.segundoNombre,
            item.primerApellido,
            item.segundoApellido,
          ]
            .filter(Boolean)
            .join(' ');

          return {
            empleadoId: item.id,
            nombreEmpleado: nombreCompleto || item.nombreEmpleado || `Empleado #${item.id}`,
            cargo: item.Cargo?.nombreCargo || item.cargo || 'Colaborador',
            modalidad: conf.modalidad || 'SUELDO_BASE',
            salarioBaseMensual: Number(conf.sueldoBaseMensual || conf.salarioBaseMensual || 0),
            porcentajeComision: Number(conf.porcentajeComision || 0),
            aplicaIHSS: conf.aplicaIHSS !== undefined ? Boolean(conf.aplicaIHSS) : true,
            aplicaRAP: conf.aplicaRAP !== undefined ? Boolean(conf.aplicaRAP) : true,
            observaciones: conf.observaciones || '',
          };
        });
      }
    } catch (err) {
      // Fallback
    }
    return getStorageItem(STORAGE_CONFIG, SEED_CONFIG_EMPLEADOS);
  },

  async guardarConfiguracion(config) {
    try {
      const resp = await AxiosPrivado.post(EmpleadosConfiguracionLaboral, {
        idEmpleado: Number(config.empleadoId),
        empleadoId: Number(config.empleadoId),
        modalidad: config.modalidad,
        salarioBaseMensual: Number(config.salarioBaseMensual || 0),
        sueldoBaseMensual: Number(config.salarioBaseMensual || 0),
        porcentajeComision: Number(config.porcentajeComision || 0),
        aplicaIHSS: Boolean(config.aplicaIHSS),
        aplicaRAP: Boolean(config.aplicaRAP),
        observaciones: config.observaciones || '',
      });
      if (resp && resp.data) {
        const configs = getStorageItem(STORAGE_CONFIG, SEED_CONFIG_EMPLEADOS);
        const index = configs.findIndex((c) => c.empleadoId === Number(config.empleadoId));
        if (index !== -1) {
          configs[index] = { ...configs[index], ...config };
        } else {
          configs.push(config);
        }
        setStorageItem(STORAGE_CONFIG, configs);
        return resp.data;
      }
    } catch (err) {
      console.warn("Fallo guardado en backend, usando fallback local:", err);
    }

    const configs = getStorageItem(STORAGE_CONFIG, SEED_CONFIG_EMPLEADOS);
    const index = configs.findIndex((c) => c.empleadoId === Number(config.empleadoId));

    if (index !== -1) {
      configs[index] = { ...configs[index], ...config };
    } else {
      configs.push(config);
    }

    setStorageItem(STORAGE_CONFIG, configs);
    return { success: true, configuracion: config };
  },

  // 9. Préstamos y deducciones
  async listarPrestamos() {
    const prestamosLocales = getStorageItem(STORAGE_PRESTAMOS, SEED_PRESTAMOS);
    let prestamosBackend = [];

    try {
      const resp = await AxiosPrivado.get(EmpleadosPrestamos);
      if (resp && resp.data) {
        const raw = Array.isArray(resp.data)
          ? resp.data
          : Array.isArray(resp.data.prestamos)
          ? resp.data.prestamos
          : Array.isArray(resp.data.data)
          ? resp.data.data
          : [];

        if (raw.length > 0) {
          const configs = getStorageItem(STORAGE_CONFIG, SEED_CONFIG_EMPLEADOS);

          prestamosBackend = raw.map((item) => {
            const empleado = item.Empleado || item.empleado || {};
            const nombreEmpleadoObj = [
              empleado.primerNombre,
              empleado.segundoNombre,
              empleado.primerApellido,
              empleado.segundoApellido,
            ]
              .filter(Boolean)
              .join(' ');

            const empId = Number(item.empleadoId || item.idEmpleado || empleado.id);
            const confEmp = configs.find((c) => Number(c.empleadoId) === empId);

            const monto = Number(item.montoOriginal ?? item.monto ?? 0);
            const cuotas = Number(item.totalCuotas ?? item.cuotas ?? 1);
            const cuota = Number(item.cuotaPeriodica ?? item.cuota ?? (cuotas > 0 ? (monto / cuotas).toFixed(2) : monto));

            return {
              id: item.id,
              empleadoId: empId,
              nombreEmpleado:
                item.nombreEmpleado ||
                nombreEmpleadoObj ||
                confEmp?.nombreEmpleado ||
                (empId ? `Empleado #${empId}` : 'Colaborador'),
              montoOriginal: monto,
              cuotaPeriodica: cuota,
              totalCuotas: cuotas,
              cuotasPagadas: Number(item.cuotasPagadas ?? 0),
              saldoPendiente: Number(item.saldoPendiente ?? item.saldo ?? monto),
              motivo: item.motivo || item.descripcion || item.tipo || 'Préstamo a colaborador',
              tipo: item.tipo || 'Prestamo',
              estado: (item.estado || 'ACTIVO').toUpperCase(),
              fechaInicio:
                item.fechaInicio ||
                item.fecha ||
                (item.createdAt ? item.createdAt.split('T')[0] : new Date().toISOString().split('T')[0]),
            };
          });
        }
      }
    } catch (err) {
      // Backend no disponible o en desarrollo
    }

    // Si el backend retornó registros, se fusionan de forma segura con los locales para no perder registros locales
    if (prestamosBackend.length > 0) {
      const idsBackend = new Set(prestamosBackend.map((p) => p.id));
      const localesRestantes = prestamosLocales.filter((pl) => !idsBackend.has(pl.id));
      const combinados = [...prestamosBackend, ...localesRestantes];
      setStorageItem(STORAGE_PRESTAMOS, combinados);
      return combinados;
    }

    // Si el backend retornó vacío ([]), conservamos íntegros los préstamos guardados localmente
    return prestamosLocales;
  },

  async guardarPrestamo(nuevoPrestamo) {
    const prestamos = getStorageItem(STORAGE_PRESTAMOS, SEED_PRESTAMOS);
    const nextId = prestamos.length > 0 ? Math.max(...prestamos.map((p) => Number(p.id) || 0)) + 1 : 1;

    const prestamo = {
      id: nextId,
      empleadoId: Number(nuevoPrestamo.empleadoId),
      nombreEmpleado: nuevoPrestamo.nombreEmpleado || `Empleado #${nuevoPrestamo.empleadoId}`,
      montoOriginal: Number(nuevoPrestamo.montoOriginal),
      cuotaPeriodica: Number(nuevoPrestamo.cuotaPeriodica),
      totalCuotas: Number(nuevoPrestamo.totalCuotas),
      cuotasPagadas: 0,
      saldoPendiente: Number(nuevoPrestamo.montoOriginal),
      motivo: nuevoPrestamo.motivo || 'Préstamo interno a colaborador',
      tipo: nuevoPrestamo.tipo || 'Prestamo',
      estado: 'ACTIVO',
      fechaInicio: nuevoPrestamo.fechaInicio || new Date().toISOString().split('T')[0],
    };

    // Intentar sincronizar con el backend
    try {
      const resp = await AxiosPrivado.post(EmpleadosPrestamos, {
        empleadoId: Number(nuevoPrestamo.empleadoId),
        idEmpleado: Number(nuevoPrestamo.empleadoId),
        tipo: prestamo.tipo,
        monto: prestamo.montoOriginal,
        montoOriginal: prestamo.montoOriginal,
        totalCuotas: prestamo.totalCuotas,
        cuotas: prestamo.totalCuotas,
        cuotaPeriodica: prestamo.cuotaPeriodica,
        cuota: prestamo.cuotaPeriodica,
        saldo: prestamo.saldoPendiente,
        saldoPendiente: prestamo.saldoPendiente,
        motivo: prestamo.motivo,
        descripcion: prestamo.motivo,
        estado: 'ACTIVO',
        fechaInicio: prestamo.fechaInicio,
      });
      if (resp && resp.data && resp.data.id) {
        prestamo.id = resp.data.id;
      }
    } catch (err) {
      console.warn('Backend aún en desarrollo para POST prestamos, guardado en persistencia local:', err);
    }

    const actualizados = [prestamo, ...prestamos.filter((p) => p.id !== prestamo.id)];
    setStorageItem(STORAGE_PRESTAMOS, actualizados);
    return { success: true, prestamo };
  },

  async eliminarPrestamo(prestamoId) {
    try {
      await AxiosPrivado.delete(`${EmpleadosPrestamos}/${prestamoId}`);
    } catch (err) {
      // Backend fallback
    }

    const prestamos = getStorageItem(STORAGE_PRESTAMOS, SEED_PRESTAMOS);
    const filtrados = prestamos.filter((p) => p.id !== Number(prestamoId));
    setStorageItem(STORAGE_PRESTAMOS, filtrados);
    return { success: true };
  },

  // 10. Recibo individual por empleado
  async obtenerReciboEmpleado(empleadoId, periodoId) {
    try {
      const resp = await AxiosPrivado.get(`${PlanillasReciboEmpleado}${empleadoId}/recibo/${periodoId}`);
      if (resp && resp.data) {
        return resp.data;
      }
    } catch (err) {
      // Fallback
    }
    const data = await this.obtenerDetallePeriodo(periodoId);
    if (!data) return null;
    const detalleEmp = data.detalles.find((d) => d.empleadoId === Number(empleadoId));
    return {
      periodo: data.periodo,
      detalle: detalleEmp,
    };
  },

  // 11. Ventas Comisionables del Período (Regla: Solo ventas saldadas al 100% / completadas)
  async obtenerVentasComisionables({ fechaInicio, fechaFin }) {
    try {
      let ventas = [];
      try {
        const resp = await AxiosPrivado.get(VentaFiltro, {
          params: {
            fechaInicio: `${fechaInicio} 00:00:00`,
            fechaFin: `${fechaFin} 23:59:59`,
          },
        });
        if (resp && resp.data && Array.isArray(resp.data)) {
          ventas = resp.data;
        }
      } catch (errFiltro) {
        const respG = await AxiosPrivado.get(VentaListar);
        if (respG && respG.data && Array.isArray(respG.data)) {
          ventas = respG.data;
        }
      }

      const ventasPorEmpleado = {};
      const inicioTimestamp = new Date(`${fechaInicio}T00:00:00`).getTime();
      const finTimestamp = new Date(`${fechaFin}T23:59:59`).getTime();

      ventas.forEach((v) => {
        if (v.estado === 'Anulada') return;

        const empId = v.empleadoId || v.Empleado?.id;
        if (!empId) return;

        const totalVenta = parseFloat(v.totalVenta || 0);
        const esCredito =
          v.tipoVenta === 'Credito' ||
          v.tipoVenta === 'Crédito' ||
          (Array.isArray(v.creditos) && v.creditos.length > 0) ||
          v.creditoId != null;

        if (!esCredito) {
          // VENTA AL CONTADO:
          // Se comisiona de inmediato si su fecha cae dentro del período actual
          const fechaVentaStr = v.fecha || v.createdAt;
          const fechaVentaTime = new Date(fechaVentaStr).getTime();
          if (fechaVentaTime >= inicioTimestamp && fechaVentaTime <= finTimestamp) {
            ventasPorEmpleado[empId] = Number(((ventasPorEmpleado[empId] || 0) + totalVenta).toFixed(2));
          }
        } else {
          // VENTA AL CRÉDITO:
          // Regla: Solo comisiona si está 100% saldada (saldo <= 0 o estado == 'Completada').
          // Y se computa en el período en el cual se completó/liquidó el pago.
          const credito = Array.isArray(v.creditos) && v.creditos.length > 0 ? v.creditos[0] : null;
          const estadoCred = (v.creditoEstado || credito?.estado || v.estado || '').trim().toLowerCase();
          const saldoCred = Number(v.creditoSaldo ?? credito?.saldo ?? 0);
          const estaSaldada = estadoCred === 'completada' || saldoCred <= 0;

          if (estaSaldada) {
            const pagos = Array.isArray(credito?.pagos) ? credito.pagos : (Array.isArray(v.pagos) ? v.pagos : []);
            let fechaLiquidacionStr = credito?.fechaLiquidacion || v.fechaLiquidacion;

            if (!fechaLiquidacionStr && pagos.length > 0) {
              const ultimoPago = pagos[pagos.length - 1];
              fechaLiquidacionStr = ultimoPago.fecha || ultimoPago.createdAt;
            }

            if (!fechaLiquidacionStr) {
              fechaLiquidacionStr = v.fecha || v.createdAt;
            }

            const fechaLiqTime = new Date(fechaLiquidacionStr).getTime();
            if (fechaLiqTime >= inicioTimestamp && fechaLiqTime <= finTimestamp) {
              ventasPorEmpleado[empId] = Number(((ventasPorEmpleado[empId] || 0) + totalVenta).toFixed(2));
            }
          }
        }
      });

      return {
        success: true,
        ventasPorEmpleado,
      };
    } catch (err) {
      console.warn('Error calculando ventas comisionables:', err);
      return { success: false, ventasPorEmpleado: {} };
    }
  },
};
